import React, {useRef} from "react"
import {useSelector} from "react-redux";

import {tabOptions, LOCKER_TABS, ENVIRONMENTS} from "utils"
import {useInitializeWebSocketConnection} from "hooks";
import {MARKET_WS} from "store/endpoint";

import {TabDynamicBlock, TabContent} from "components/molecules";
import LockerListedCosmetics from "./LockerListedCosmetics";
import LockerOwnedCosmetics from "./LockerOwnedCosmetics";
import LockerConvert from "./Konvert/LockerConvert";
import LockerActivity from "./LockerActivity";

const LockerCosmetics = ({activeTab, changeTab, lockerCosmeticRef}) => {
    const {userData} = useSelector(state => state.authV2.signIn)

    const lockerTabRef = useRef(null)
    const server = `${ENVIRONMENTS.WS_MARKET_URL}${MARKET_WS.KONVERT_CHECK}?user-xsolla-id=${userData.id}`

    const {isReceivedData} = useInitializeWebSocketConnection({server, isReConnectWebSocket: true})

    return (
        <section className="locker_cosmetics" ref={lockerCosmeticRef}>
            <div className="locker_cosmetics_tabs" ref={lockerTabRef}>
                <TabDynamicBlock
                    options={tabOptions}
                    activeTab={activeTab}
                    isSetUrlParams={false}
                    setActiveTab={changeTab}
                />
            </div>
            <div className="locker_cosmetics_content">
                <div className="locker_cosmetics_content_general">
                    <TabContent id={LOCKER_TABS.OWNED} activeTab={activeTab}>
                        <LockerOwnedCosmetics parentSectionRef={lockerCosmeticRef}/>
                    </TabContent>
                    <TabContent id={LOCKER_TABS.LISTED} activeTab={activeTab}>
                        <LockerListedCosmetics/>
                    </TabContent>
                    <TabContent id={LOCKER_TABS.ACTIVITY} activeTab={activeTab}>
                        <LockerActivity/>
                    </TabContent>
                    <TabContent id={LOCKER_TABS.KONVERT} activeTab={activeTab}>
                        <LockerConvert isSocketReceivedData={isReceivedData}/>
                    </TabContent>
                </div>
            </div>
        </section>
    )
}

export default LockerCosmetics